<template>
    <div id="topRuleList">
        <!-- 场景库 -->
        <div class="typeBox">
            <div class="leftImg">
                <img :src="imgArr.img_left" alt="">
            </div>
            <div class="imgBox" :class="ruleCheckKey == item.type?'imgBoxCheck':''"  v-for="(item,index) in ruleListArr" :key="index">
                <img :src="item.img" alt="" @click="ruleListClick(item,index)" />
            </div> 
        </div>
    </div>
</template>
<script>

// 接收方组件
import { EventBus } from '@/assets/js/event-bus.js';

//引入图片
import img_left from '@/assets/images/ruleList/img_left.png'

//引入列表
import { ruleList } from '@/config/ruleList.js'

//console.log(ruleList)

export default {
    name:'',
    data(){
        return{
            //图片地址
            imgArr:{
                img_left:img_left
            },
            //列表展示
            ruleListArr:ruleList,
            ruleCheckKey:'',
        }
    },
    created(){
        //绑定 跨组件通讯函数
        EventBus.$on('dataForOtherRoute', (data) => {
            this.ruleCheckKey = data.path
        });
    },
    mounted(){
        setTimeout(() => {
            //获取路由参数
            if(this.$route.query.path){
                this.ruleCheckKey = this.$route.query.path
            }
        }, 200);
    },
    beforeDestroy() {
        EventBus.$off('dataForOtherRoute');
    },
    methods:{
        //列表点击事件
        ruleListClick(item,index){
            this.ruleCheckKey = item.type
            //进入场景规则库定制  路由页面
            let sendObj = {
                path:item.type,
                pId:item.rootCategoryId,
                thatId:item.childsFirstId,
            }
            this.$router.push({
                path:'/rule',
                query:sendObj
            })
        },
        //改变列表的选中状态
        changeListCheck(data){
            this.ruleCheckKey = data.path
        },
    },
    
}
</script>
<style lang="scss" scoped>
#topRuleList{
    width:100%;
    height:230px;
    padding-top:20px;
    background: #F3F8FC;
    box-sizing: border-box;
}
.typeBox {
    width: 1200px;
    display: flex;
    margin: 0 auto;
    height: 210px;
    justify-content: space-between;
    .leftImg{
        width:70px;
        height:210px;
        margin-right: 0px;
        img{
            width:100%;
            height:100%;
        }
    }
    .imgBox{
        width:110px;
        height:210px;
        img{
            width:100%;
            height:100%;
        }
    }
}
.imgBox img{
  cursor: pointer;
}
.imgBoxCheck{
    img{
        transform: translateY(-10px)!important;
    }
}
.imgBox img:hover {
  transform: translateY(-10px);
}
</style>
